import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { LOADING_STATES, useRothko } from "web/react/hooks/use-rothko/use-rothko";
import LoadingSpinner from "web/react/components/loading-spinner/loading-spinner";
import classnames from "classnames";
import styles from "./related-search-product-images.css";

function RelatedSearchProductImages({ feedUrl, isRoundedImage, showFallBack }) {
    const ENDPOINT = "modules/related_search_products";

    const rothkoOptions = useMemo(() => ({ feed_url: feedUrl }), [feedUrl]);
    const { data, loadingState } = useRothko(ENDPOINT, rothkoOptions);

    const pending = loadingState == LOADING_STATES.PENDING;
    const complete = loadingState == LOADING_STATES.COMPLETE;
    const completeWithImages = complete && data.products.length > 0;
    const completeNoImages = complete && data.products.length == 0;

    return (
        <div className={styles.relatedSearchImages}>
            {completeNoImages && showFallBack && <span className={styles.fallback}>{"L"}</span>}
            {completeWithImages &&
                data.products.map((product) => {
                    return (
                        <img
                            key={product.image_url}
                            src={product.image_url}
                            alt={product.alt_text}
                            className={classnames(styles.relatedSearchImage, {
                                [styles.relatedSearchImageRounded]: isRoundedImage,
                            })}
                        />
                    );
                })}
            {pending && <LoadingSpinner />}
        </div>
    );
}

RelatedSearchProductImages.defaultProps = {
    isRoundedImage: false,
    showFallBack: false,
};

RelatedSearchProductImages.propTypes = {
    feedUrl: PropTypes.string.isRequired,
    isRoundedImage: PropTypes.bool,
    showFallBack: PropTypes.bool,
};

export default RelatedSearchProductImages;
